import Component from 'vue-class-component';
import { getQueryString } from '@/utils/location';
import Vue from 'vue';
import moduleStore from './store/activityManager';
import activityMixin from '@/mixins/activity-mixin'

@Component({
  mixins: [activityMixin]
})
@moduleStore.initVuex({
  mutationNames:moduleStore.mutationNames,
  actionNames:moduleStore.actionNames
})
export default class ActivityMangerPage extends Vue  {
  accountList: any = []
  wwToken = ''
  descList = [
    '1.已授权的账号报名活动即可参与无需再次授权',
    '2.授权失效的账号重新授权后即可恢复数据统计',
    '3.满足条件的作品将自动计算数据进行排名'
  ]
  mode = 'edit' // 当前模式
  show = false
  delItem:any = {} // 需要删除的账号
  platformMap={'dou_yin':'抖音','kuai_shou':'快手'};
  mounted() {
    this.initData()
  }
  initData() {
    this.wwToken = getQueryString('ww_token') || localStorage.getItem('ww_token')
    if (!this.wwToken) return
    this.getDouYinUser()
  }
  /**
   * 获取抖音账号
   */
  getDouYinUser() {
    this.$http('queryDouYinUser').then((res: any) => {
      if (res.code === 200) {
        this.accountList = res.data
      }
    })
  }
  handleBtnTap() {
    this.$router.push(`/accredit?ww_token=${this.wwToken}&type=add`)
  }
  handleModeTap(type: string) {
    this.mode = type
  }
  /**
   * 删除某个账
   * @param item
   */
  delAccountTap(item: any) {
    this.show = true
    this.delItem = item
  }
  /**
   * 确认删除
   */
  confirmDel() {
    const params = {
      id: this.delItem.id
    }
    this.$http('delBindInfo', params).then(res => {
      if (res.code === 200) {
        this.show = false
        this.getDouYinUser()
      }
    })
  }
  
}